// Ultra-aggressive lazy loading for maximum performance
(function() {
  'use strict';
  
  // Very small intersection margin - load images only when very close
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        
        // Load the image
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
        
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
          img.removeAttribute('data-srcset');
        }
        
        img.classList.remove('lazyload');
        img.classList.add('lazyloaded');
        
        // Stop observing this image
        observer.unobserve(img);
      }
    });
  }, {
    // Load images only 50px before they enter viewport (very aggressive)
    rootMargin: '50px 0px',
    threshold: 0.01
  });
  
  // Observe all lazy images except critical ones, app blocks, and header elements
  function observeLazyImages() {
    const lazyImages = document.querySelectorAll('img[data-src]:not(.critical)');
    lazyImages.forEach(img => {
      // Don't lazy load critical above-the-fold images or images in app blocks
      const isCritical = img.closest('.hero, .banner, .slideshow, .slider') || 
                        img.classList.contains('product-first-img');
      
      // Exclude images in app blocks (instafeed, elfsight, etc.) from lazy loading
      const isInAppBlock = img.closest('[class*="shopify-app"], [class*="instafeed"], [class*="elfsight"], [data-app-block]');
      
      // Exclude header/navigation elements from lazy loading
      const isInHeader = img.closest('header, nav, .top-header, .header, .navigation, .navbar, .hamburger');
      
      if (!isCritical && !isInAppBlock && !isInHeader) {
        imageObserver.observe(img);
      }
    });
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeLazyImages);
  } else {
    observeLazyImages();
  }
  
  // Re-observe when new images are added dynamically
  // But exclude app blocks and header elements from mutation observation to avoid interference
  const mutationObserver = new MutationObserver(mutations => {
    let hasNewImages = false;
    mutations.forEach(mutation => {
      // Skip mutations in header/navigation
      if (mutation.target.closest && mutation.target.closest('header, nav, .top-header, .header, .navigation, .navbar, .hamburger')) {
        return;
      }
      
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          // Skip app blocks and header elements
          if (node.nodeType === 1) {
            const isAppBlock = node.matches && (
              node.matches('[class*="shopify-app"]') ||
              node.matches('[class*="instafeed"]') ||
              node.matches('[class*="elfsight"]') ||
              node.matches('[data-app-block]')
            );
            
            const isHeader = node.matches && (
              node.matches('header') ||
              node.matches('nav') ||
              node.matches('[class*="header"]') ||
              node.matches('[class*="navigation"]') ||
              node.matches('[class*="navbar"]') ||
              node.matches('[class*="hamburger"]')
            );
            
            if (!isAppBlock && !isHeader) {
              if (node.matches && node.matches('img[data-src]')) {
                hasNewImages = true;
              } else if (node.querySelector && node.querySelector('img[data-src]')) {
                hasNewImages = true;
              }
            }
          }
        });
      }
    });
    
    if (hasNewImages) {
      setTimeout(observeLazyImages, 100);
    }
  });
  
  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  
})();